
import { IDynamicFormPayload } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { buttonTypes } from '@ispm/shared/components/button/button.component';
import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';

export interface IFormLoaderPayload extends  IDynamicFormPayload {
  actions?: Array<{
    name?: string;
    cssClass?:string;
    iconClass: string;
    type?: buttonTypes;
    childFormId:string;
    actionMode?:string;
    childFormtitle?:string;
    paramsToPick?: Array<paramToPick>;
  }>;
  paramsToPick?:Array<paramToPick>;
  formVertical?:boolean;
  disableMode?:{
    key:string,
    value:string
  }[]
}
export enum ActionMode {
  openPopup="Popup"
}

export interface paramToPick {
  source?: string;
  dest?: string;
}
